import { t } from "@lingui/macro";
import { WfCard, WfCarousel } from "@WahooFitness/redesignr";
import { Box } from "@mui/material";
import { WfCardProps } from "@WahooFitness/redesignr/Components/WfCard/WfCard.js";

function EducationSection({ educationCards }: { educationCards: WfCardProps[] }) {
  return (
    <Box py={2}>
      <WfCarousel
        title={t`Education`}
        items={educationCards.map((card, i) => (
          <WfCard {...card} key={i} />
        ))}
      />
    </Box>
  );
}

export default EducationSection;
